module.exports = __webpack_public_path__ + "img/ready.71d37c26.gif";